"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FlexContainer = _interopRequireDefault(require("./FlexContainer"));

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  ", " {\n    margin-left: 15px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonFlexContainer = (0, _styledComponents.default)(_FlexContainer.default)(_templateObject(), function (_ref) {
  var marginTop = _ref.marginTop;
  return marginTop;
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom;
}, _FlexItem.default);
ButtonFlexContainer.propTypes = {
  /** Margin top override */
  marginTop: _propTypes.default.string,

  /** Margin bottom override */
  marginBottom: _propTypes.default.string
};
ButtonFlexContainer.defaultTypes = {
  marginTop: '40px',
  marginBottom: '30px'
};
var _default = ButtonFlexContainer;
exports.default = _default;